import styled from 'styled-components'

export const IconWrapper = styled.div`
	margin-right: 6px;
	display: flex;
	align-items: center;
`
